export { default } from './WaveDistribution';
